import React from "react";
import LogoLoader from "./LogoLoader";

const ScreenLoader = ({ message = "" }) => {
  return (
    <div className="fixed inset-0 z-[99] bg-black/30 flex justify-center items-center">
      <div role="status" className="flex flex-col items-center">
        <LogoLoader size={58} label={message || "Loading"} />
        {message && (
          <span className="mt-3 text-primaryColor text-base font-medium text-center">
            {message}
          </span>
        )}
      </div>
    </div>
  );
};

export default ScreenLoader;
